<template>
  <a href="#" @click.prevent="click">
    <aw-icon icon="user" class="w-5 h-5 "></aw-icon>
    {{$t('Add public user')}}
  </a>
</template>

<script>

export default {
  props: ['defaultTeam'],
  methods: {
    click() {
      this.$formValues['frm-publicUserForm-publicUserForm-id'] = ''
      this.$formValues['frm-publicUserForm-publicUserForm-name'] = ''
      this.$formValues['frm-publicUserForm-publicUserForm-public_ips'] = '*.*.*.*'

      for (const inputName in this.$formValues) {
        if (inputName.startsWith('frm-publicUserForm-publicUserForm-teams')) {
          let teamNumber = inputName.split('-')[4]
          if (teamNumber == this.defaultTeam) {
            this.$formValues[inputName] = 7
          } else {
            this.$formValues[inputName] = 0
          }
        }
      }

      //TODO: reset user groups
      this.$store.commit('nette/updateControl', {
        controlName: 'publicUserForm',
        data: true,
        key: 'showModal',
      })
    }
  },
}
</script>

<style lang="scss" scoped></style>
